import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "./components/common";
import ScrollToTop from "./components/common/ScrollToTop";
import ErrorBoundary from "./components/common/ErrorBoundary";
import Seo from "./components/common/Seo";
import HomePage from "./pages/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Seo
                    title="Fork - AI Nutrition Tracking App | Photo-Based Meal Analysis"
                    description="Fork is an AI-powered nutrition tracking app for iOS and Android. Take a photo of your meal and instantly get nutrition scores, macro breakdowns, and AI insights. Voice logging supported. Free to download."
                    path="/"
                  />
                  <Layout>
                    <HomePage />
                  </Layout>
                </>
              }
            />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
